export const getAdminPath = () =>
  `${process.env.REACT_APP_PROTOCOLL}${process.env.REACT_APP_SERVER_URL}`
